<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 21 19">
    <path
      d="M9.97714 17.8433C9.64043 17.8433 9.37587 17.5889 9.37587 17.2651H8.17334C8.17334 18.225 8.97904 18.9998 9.97714 18.9998C10.9752 18.9998 11.7809 18.225 11.7809 17.2651H10.5784C10.5784 17.5889 10.3018 17.8433 9.97714 17.8433Z"
      :class="colorClass"
    />
    <path
      d="M10.9632 1.98904C13.9455 1.98904 16.3746 4.38284 16.3746 7.33171V12.2928L17.5771 13.4492V7.33171C17.5771 3.9434 14.9316 1.15642 11.5645 0.855752V0H10.3619V0.867316C8.36574 1.04078 6.62207 2.09312 5.53979 3.6196L6.45372 4.38284C7.42777 2.93731 9.07524 1.98904 10.9632 1.98904Z"
      :class="colorClass"
    />
    <path
      d="M20.7158 17.3578L3.65188 3.35352L2.85821 4.24396L4.31328 5.43507C3.72403 6.40647 3.3753 7.5282 3.3753 8.73087V12.5355C3.3753 14.6864 1.79998 16.236 1.78796 16.2592L0.777832 17.2421H18.7076L19.9342 18.2482L20.7278 17.3578H20.7158ZM3.43543 16.0973C3.96454 15.2993 4.57783 14.062 4.57783 12.5471V8.74244C4.57783 7.8173 4.83036 6.96155 5.25125 6.20988L17.3006 16.0973H3.4234H3.43543Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
